export const notImplementedFunction = () => {
    throw new Error('Function not implemented.');
};
